module.exports = __webpack_public_path__ + "img/Why-do-apps-need-constant-updates_.57a61e5f.png";